<!-- 功能定义 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :dict="[]"
      :option="{}"
      :colObj='{
        opId: 105,
        col:[]
      }'
    >
    </Table>
  </div>
</template>
<script>
import Table from '@/components/table/dataTablec';
import {processDeal} from "@/api/home/home";
export default {
  components: {
    Table
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    // 数据定义  行按钮点击
    dataDefinitionRowClick(btn,row){
      this.$router.push({
        path:'/system/functionSon',
        query:{
          runId:this.$route.query.runId,
          OP_ID:row.ID,
          sname:row.OP_NAME,
        }
      })
    },
    // 复制  行按钮点击
    copyRowClick(btn,row){
      processDeal({obj:JSON.stringify({id:41,runId:this.$route.query.runId,opid:row.ID})}).then(res=>{
        this.$message.success("复制成功!");
        this.$refs.table.$refs.child.onLoad();
      },err=>{
        this.loading=false;
      })
    },
  },
  created() {
  },
  mounted() {},
  activated() {
  },
};
</script>

<style lang="scss" scoped>
</style>
